import { createElement } from "@/utils/create-elem.js";
import { LevelBar } from "./levelBar/LevelBar.js";
import { GameSection } from "./gameSection/GameSection.js";
import { ControlsBar } from "./controlsBar/ControlsBar.js";
import "@/styles/style.scss";
import "@/styles/components/level-bar.scss";

export function Main(parent) {
  const main = createElement({
    tag: "main",
    classes: ["main"],
    parent: parent,
  });
  LevelBar(main);
  GameSection(main);
  ControlsBar(main);
}
